import { Table, Col, Card, Space, Modal, Radio,Image,Spin} from "antd"
import { ToolTypes, getMessages,deleteMessages as deleteMessagesAPI,deleteUserMessages,markAllRead as markAllReadAPI } from "../../API";
import { Metrics, Helpers, Colors,Spacing,channelColors,Fonts,toolSyncTime,otaStates,Images,sensorLive } from '../../global'
import { Row,Text,View,Icon, Graph,Alert} from "../../Components"
import {
    ArrowLeftOutlined
} from "@ant-design/icons"
import { useEffect, useState, useRef } from "react"
import { useRecoilState } from "recoil"
import { allSitesAtom } from "../../Atoms/allSitesAtom"
import { useAuthenticator } from '@aws-amplify/ui-react'
import { useMatch } from 'react-router-dom'
import { useNavigate } from "react-router-dom"
import { ReactComponent as analogIcon} from '../../Assets/SVG/Analog_Small.svg'
import { ReactComponent as therm4Icon} from '../../Assets/SVG/4Ch_Small.svg'
import { ReactComponent as chemIcon} from '../../Assets/SVG/ChemSense_Small.svg'
import { ReactComponent as swimIcon} from '../../Assets/SVG/SwimSense_Small.svg' 
import { ReactComponent as thpIcon} from '../../Assets/SVG/THP_Small.svg'
import { ReactComponent as toolIcon} from '../../Assets/SVG/ToolIcon_Small.svg'
import { ReactComponent as addIcon} from '../../Assets/SVG/AddTool_Small.svg'
import { ReactComponent as troubleshootIcon} from '../../Assets/SVG/Troubleshoot_Small.svg'
import { ReactComponent as userIcon} from '../../Assets/SVG/User_Small.svg'
import { ReactComponent as appearanceIcon} from '../../Assets/SVG/Appearance_Small.svg'
import { ReactComponent as closeIcon} from '../../Assets/SVG/Close.svg'
import { ReactComponent as deleteIcon} from '../../Assets/SVG/Delete.svg'
import { ReactComponent as checkIcon} from '../../Assets/SVG/check.svg'
import { ReactComponent as filterIcon} from '../../Assets/SVG/Filter.svg'
import { ReactComponent as sortIcon} from '../../Assets/SVG/Sort.svg'
import { ReactComponent as optionsIcon} from '../../Assets/SVG/Options2.svg'
import { ReactComponent as pending} from '../../Assets/SVG/Pending.svg'
import _ from 'lodash'

let selectedTemp = []
let sortedMessagesTemp = []
const messageAttributes = "msgType,message_id,settings,alert_id,ts,message,alertContent,mac,toolType"

function useMergeState(initialState) {
    const [state, setState] = useState(initialState)
    const setMergedState = (newState) =>
      setState((prevState) => Object.assign({}, prevState, newState))
    return [state, setMergedState]
  }

function Settings() {
    let sortActionSheet = null
    let optionsActionSheet = null
    let options = ['Delete All','Mark All Read']
    let sortOptions = ['Time (Newest First)','Time (Oldest First)','Tool','Type']
    const match = useMatch('/settings/:mac')
    const macAddress = match?.params.mac;
    const ref = useRef();
    const { user } = useAuthenticator((context) => [context.user]);
    const [allSites, setAllSites] = useRecoilState(allSitesAtom)
    const activeSite = Object.values(allSites).flatMap(arr => arr).find(obj => obj.mac === macAddress)
    // const tools = useSelector((state) => getTools(state)) //allSites
    let toolMacs = []// useSelector((state) => getToolMacs(state))
    if(allSites.tools) allSites.tools.forEach((element) => toolMacs.push(element.key));
    // let messages
    // if(allSites.messages) messages = allSites.messages
    const [messages,setMessages] = useState(allSites.messages?allSites.messages:undefined)
    const [sorted,setSorted] = useState(allSites.sorted?allSites.sorted:undefined)
    // let sorted
    // if(allSites.sorted) sorted = allSites.sorted
    // let messages = useSelector((state) => getMessages(state)) //allSites.messages
    // const messageStatus = useSelector((state) => getStatus(state))
    // const sorted = useSelector((state) => getSortedMessages(state)) //allSites.sorted
    const [sortMode,setSortMode] = useState(_.has(sorted,"mode")?sorted?.mode:0)
    const [filters,setFilters] = useState(_.has(sorted,"filters")?sorted?.filters:{msgType:["tool","alert","team","promo"],tool:toolMacs})
    let sortedMessages = sorted?.messages
    const [selectMode,setSelectMode] = useState(false)
    const [selected,setSelected] = useState(selectedTemp)
    const [selectedCount,setSelectedCount] = useState(selectedTemp.length)
    const [lastSelected,setLastSelected] = useState(null)
    const [isLoading, setIsLoading] = useState(allSites.messages != undefined?false:true)
    const [refreshing, setRefreshing] = useState(false)
    const [deleteMessages, setDeleteMessages] = useState(false)
    const [deleteAllMessages, setDeleteAllMessages] = useState(false)
    const [deleteLoading, setDeleteLoading] = useState(false)
    const [deleteAllLoading, setDeleteAllLoading] = useState(false)
    const [markAllRead, setMarkAllRead] = useState(false)
    const [markAllReadLoading, setMarkAllReadLoading] = useState(false)
    const [showSort,setShowSort] = useState(false)
    const [showSettings,setShowSettings] = useState(false)
    const [showFilters,setShowFilters] = useState(false)
    const [allTypes,setAllTypes] = useState(false)
    const [tool,setTool] = useState(filters.msgType.find(element => element == "tool")!=undefined)
    const [alert,setAlert] = useState(filters.msgType.find(element => element == "alert")!=undefined)
    const [team,setTeam] = useState(filters.msgType.find(element => element == "team")!=undefined)
    const [promo,setPromo] = useState(filters.msgType.find(element => element == "promo")!=undefined)
    const [allTools,setAllTools] = useState(false)
    const [toolFilters, setToolFilters] = useMergeState(buildToolFilters())
    const [height, setHeight] = useState();
    const navigate = useNavigate();
    const pullMessages = async () => {
        if(user.signInUserSession.idToken.jwtToken && !_.isEmpty(allSites)){
            console.log('REPULLING MESSAGES')
            setIsLoading(true)
            let messages = await getMessages(messageAttributes).then(data => {
                console.log('data:',data)
                return data
            })
            let unreadMessages = 0
            if(messages){
                messages.forEach((message) => {   
                    if (!message.settings.read) unreadMessages++
                });
            }
            let tempAllSites = _.cloneDeep(allSites)
            tempAllSites['messages'] = messages
            tempAllSites['unreadMessages'] = unreadMessages
            console.log('pullMessages Updating AllSites to ',tempAllSites)
            setAllSites(tempAllSites)
            setIsLoading(false)
        }
    }
    useEffect(() => {
        return () => {
            selectedTemp = []
            setSelectMode(false)
            setSelected(selectedTemp)
            setSelectedCount(0)
        }
    }, [])
    useEffect(() => {
        if(deleteLoading){
          try {
            deleteMessagesAPI(selected).then((result)=>{
                console.log('deleteMessagesAPI result:',result)
                if(result == true){
                    let tempAllSites = _.cloneDeep(allSites)
                    selected.forEach(id => {
                        if (!tempAllSites['messages'].get(id).settings.read) tempAllSites['unreadMessages']--
                        tempAllSites['messages'].delete(id)
                    })
                    console.log('deleteLoading Messages Updating AllSites to ',tempAllSites)
                    setAllSites(tempAllSites)
                }
                setDeleteLoading(false)
            })
          } catch (error) {
            console.log("DELETE ERROR:", error)
          }
        }else{
          selectedTemp = []
          setSelected(selectedTemp)
          setSelectedCount(selectedTemp.length)
          setSelectMode(false)
          setDeleteMessages(false)
        }
      }, [deleteLoading]);
      useEffect(() => {
        if(deleteAllLoading){
          try {
            deleteUserMessages().then((result)=>{
                if(result == true){
                    let tempAllSites = _.cloneDeep(allSites)
                    tempAllSites['unreadMessages'] = 0
                    tempAllSites['messages'] = new Map()
                    console.log('deleteAll Messages Updating AllSites to ',tempAllSites)
                    setAllSites(tempAllSites)
                }
                setDeleteAllLoading(false)
            })
          } catch (error) {
            console.log("DELETE ALL ERROR:", error)
          }
        }else{
          setDeleteAllMessages(false)
        }
      }, [deleteAllLoading]);
      useEffect(() => {
        if(markAllReadLoading){
          try {
            markAllReadAPI().then((result)=>{
                if(result == true){
                    pullMessages()
                }
                setMarkAllReadLoading(false)
            })
          } catch (error) {
            console.log("MARK ALL ERROR:", error)
          }
        }else{
          setMarkAllRead(false)
        }
      }, [markAllReadLoading]);
    useEffect(() => {
        if(messages && !_.isEmpty(allSites)) sortMessages(sortMode,filters,messages)
    }, [sortMode,filters,messages]);
    useEffect(() => {
        if(!_.isEmpty(allSites)){
            console.log('Messages - allSites not empty:',allSites)
            if(!_.isEqual(allSites.messages,messages) || messages == undefined){
                if(!_.isEqual(allSites.messages,undefined)){
                    setMessages(allSites.messages)
                    setIsLoading(false)
                }else{
                    pullMessages()
                }
            }
            if(!_.isEqual(allSites.sorted,sorted) || sorted == undefined){
                if(allSites.sorted){
                    setSorted(allSites.sorted)
                }
            }

        }else{
            console.log('Messages - allSites empty:',allSites)
        }
    }, [allSites]);
    ///
    useEffect(() => {//Set allTypes
        if(allTypes){
            setTool(true)
            setAlert(true)
            setTeam(true)
            setPromo(true)
        }
    }, [allTypes]);

    useEffect(() => {//Set allTools
        if(allTools){
            toolMacs.forEach(mac => {
                setToolFilters({[mac]:true})
            });  
        }
    }, [allTools]);

    useEffect(() => {//Update filters
        updateFilters(tool,alert,team,promo,toolFilters)
    }, [tool,alert,team,promo,toolFilters]);

    function buildToolFilters(){
        let object = {}
        filters.tool.forEach(tool => {
            _.set(object,tool,true)
        })
        return object
    }
    function updateFilters(tool,alert,team,promo,toolFilters){
        let tempFilters= {msgType:[],tool:[]}
        if(tool) tempFilters.msgType.push("tool")
        if(alert) tempFilters.msgType.push("alert")
        if(team) tempFilters.msgType.push("team")
        if(promo) tempFilters.msgType.push("promo")
        if(toolFilters){
            Object.keys(toolFilters).forEach(key => {
                if(toolFilters[key]== true) tempFilters.tool.push(key)
            }); 
        }
        setFilters(tempFilters)
    }
    useEffect(() => {
        const observer = new ResizeObserver(entries  => {
            console.log('RESIZE:',entries[0].contentRect)
            setHeight(entries[0].contentRect.height * 0.7)
        })
        if(ref.current){
          observer.observe(ref.current)
        }
        return () => ref.current && observer.unobserve(ref.current)
      }, [ref.current])
    ///

    const sortMessages = (mode,filters,messages) => {
        let toolArray = []
        let restArray = []
        if(!_.isEmpty(filters)){
            sortedMessagesTemp = []
            console.log("Sort Messages:")
            console.log("mode:",mode,"filters:",filters,"messages:",messages)
            let messageArray = Array.from(messages.values())
            // alertArray = messageArray.filter((item) => item.msgType == "alert")
            toolArray = messageArray.filter((item) => item.msgType == "tool" || item.msgType == "alert")
            restArray = messageArray.filter((item) => item.msgType != "alert" && item.msgType != "tool")
            if(_.has(filters,'msgType')){
            filters.msgType.forEach(type => {
                if(type == "alert"){
                let alerts = messageArray.filter((item) => item.msgType == type)
                filters.tool.forEach(tool => {
                    sortedMessagesTemp = sortedMessagesTemp.concat(alerts.filter((alert) => alert.alertContent.mac == tool))
                })
                sortedMessagesTemp = sortedMessagesTemp.concat(alerts.filter((alert) => _.findIndex(toolMacs,alert.alertContent.mac) == -1 && _.findIndex(sortedMessagesTemp,alert) == -1))
                }else if(type == 'tool'){
                let tools = messageArray.filter((item) => item.msgType == type)
                filters.tool.forEach(tool => {
                    sortedMessagesTemp = sortedMessagesTemp.concat(tools.filter((msg) => msg.mac == tool))
                })
                sortedMessagesTemp = sortedMessagesTemp.concat(tools.filter((msg) => _.findIndex(toolMacs,msg.mac) == -1 && _.findIndex(sortedMessagesTemp,msg) == -1))
                }else{
                sortedMessagesTemp = sortedMessagesTemp.concat(messageArray.filter((item) => item.msgType == type))
                }
                
            });
            }
        } else{
            sortedMessagesTemp = Array.from(messages.values())
        }
        switch (mode) {
            case 0:
            sortedMessagesTemp = sortedMessagesTemp.sort((a, b) => a.ts < b.ts ? 1 : -1)
            break;
            case 1:
            sortedMessagesTemp = sortedMessagesTemp.sort((a, b) => a.ts > b.ts ? 1 : -1)
            break;
            case 2:
            toolArray = sortedMessagesTemp.filter((item) => item.msgType == "tool" || item.msgType == "alert")
            sortedMessagesTemp = toolArray.sort((a,b) => {
                let aMac
                let bMac
                if(_.has(a,"alertContent")){
                aMac = a.alertContent.mac
                }else{
                aMac = a.mac
                }
                if(_.has(b,"alertContent")){
                bMac = b.alertContent.mac
                }else{
                bMac = b.mac
                }
                return aMac < bMac ? 1 : -1
            })
            sortedMessagesTemp = sortedMessagesTemp.concat(restArray)
            break;
            case 3:
            sortedMessagesTemp = sortedMessagesTemp.sort((a, b) => a.msgType < b.msgType ? 1 : -1)
            break;
            default:
            break;
        }
        let tempAllSites = _.cloneDeep(allSites)
        tempAllSites['sorted'] = {mode:mode,filters:filters,messages:sortedMessagesTemp}
        console.log('sortMessages Updating AllSites to ',tempAllSites)
        setAllSites(tempAllSites)
    }
    const addSelected = (id) => {
        if(_.isEmpty(selectedTemp)){
          setSelectMode(true)
        }
        selectedTemp.push(id)
        setSelected(selectedTemp)
        setSelectedCount(selectedTemp.length)
        setLastSelected(id)
    }

    const removeSelected = (id) => {
        let index = selectedTemp.indexOf(id)
        selectedTemp.splice(index,1)
        if(_.isEmpty(selectedTemp)){
          setSelectMode(false)
        }
        setSelected(selectedTemp)
        setSelectedCount(selectedTemp.length)
        setLastSelected(id)
    }

    return (
        <View style={{height:'calc(100vh - 50px)',overflow:'clip'}}>
        <View style={{display:'flex',flexDirection: 'column',width:'100%',height:'100%',overflow:'auto'}}>
        <div ref={ref} style={{display:'flex',flexDirection: 'column',width:'100%',height:'100%'}}>
            <View style={{overflow:'none'}}>
                <Row.PageTitle 
                    title={selectedCount?(selectedCount+" Selected"):"Messages"}
                    left={selectedCount?{ icon: closeIcon, onPress: () => {
                        selectedTemp = []
                        setSelected(selectedTemp)
                        setSelectedCount(selectedTemp.length)
                        setSelectMode(false)
                      } }:null}
                    right={selectedCount?{ icon: deleteIcon, onPress: () => {
                        setDeleteMessages(true)
                      } }:{ icon: filterIcon, onPress: () => {
                        setShowFilters(true)
                        // NavigationService.navigate('Modal',
                        // {screen: 'MessageFilters',params: {
                        //   navigation:navigation,
                        //   applyFilters:setFilters 
                        // }})
                      } 
                      }
                    } 
                      right2={selectedCount?null:{ icon: sortIcon, onPress: () => setShowSort(true)}}
                      right3={selectedCount?null:{ icon: optionsIcon, onPress: () => setShowSettings(true) }}
                />
            </View>
            <View style={{display:'flex',flexDirection: 'column',width:"100%",flex:1,overflow:'auto'}}>
            {!_.isEmpty(sortedMessages) ? (
                <View style={{display:'flex',flexDirection: 'column',width:"100%",flex:1,overflow:'auto'}}>
                    {sortedMessages.map((item, index) => (
                        (_.has(item,"message") && _.has(item,"msgType") && _.has(item,"ts") && _.has(item.message,"body") && _.has(item.message,"title"))?(
                        <Row.Message
                            key={item.message_id}
                            tool={_.has(item,"mac")?allSites[item.mac]:_.has(item.alertContent,"mac")?allSites[item.alertContent.mac]:null}
                            toolType={item.toolType}
                            message ={item}
                            addSelected = {addSelected}
                            removeSelected = {removeSelected}
                            selectMode = {selectMode}
                            messages = {sortedMessages}
                            lastSelected = {lastSelected}
                            selected = {selected}
                            updateCallback={()=>{
                                let tempAllSites = _.cloneDeep(allSites)
                                let newMessage = tempAllSites.messages.get(item.message_id)
                                newMessage.settings.read = true
                                console.log('NEW MESSAGE:',newMessage)
                                tempAllSites.messages.set(item.message_id,newMessage)
                                console.log('NEW allSites:',tempAllSites)
                                tempAllSites['unreadMessages']--
                                console.log('Message Updating AllSites to ',tempAllSites)
                                setAllSites(tempAllSites)
                            }}//Update read attribute
                        />):(<></>)
                    ))}
                </View>
            ):isLoading && !refreshing?<View  style={{...Helpers.fillCenter,height:'100%'}}>
            <Spin size="large" />
          </View>:(
                <View style={{...Helpers.colCross, ...Metrics.largeTopMargin,flex:1,height:'100%'}}>
                <img style={{height:180,width:180}} src={Images.noMessages} resizeMode={'contain'}/>
                <Text
                    color="primary"
                    style={{ ...Helpers.textCenter, ...Fonts.normal, ...Metrics.smallVerticalPadding }}
                >
                    {'Tool alerts, messages, and promotions will appear here.'}
                </Text>
                </View>
            )}
      <Modal
            title={'Sort By'}
            closeIcon={null}
            open={showSort}
            footer={null}
            onCancel={() => {
                setShowSort(false);
            }}
            onOk={() => {
                setShowSort(false);
            }}
            onClick={(event)=>{
                event.stopPropagation();
                setShowSort(false);
            }}
        >
            <View onClick={(event)=>{
            event.stopPropagation();
            }}>
            <Radio.Group
                onChange={(e) => {
                    console.log('radio checked', e.target.value);
                    if (e.target.value == undefined) {

                    }else {
                        setSortMode(e.target.value)
                    }
                    setShowSort(false);
                }} 
                value={sortMode}
            >
                <Space direction="vertical">
                {sortOptions.map((item,index) =>(
                    <Radio value={index}>{item}</Radio>
                    ))}
                </Space>
            </Radio.Group>
            </View>
        </Modal>
        <Modal
            title={'Message Options'}
            closeIcon={null}
            open={showSettings}
            footer={null}
            onCancel={() => {
                setShowSettings(false);
            }}
            onOk={() => {
                setShowSettings(false);
            }}
            onClick={(event)=>{
                event.stopPropagation();
                setShowSettings(false);
            }}
        >
            <View onClick={(event)=>{
            event.stopPropagation();
            }}>
                <Space direction="vertical">
                <View style={{cursor:'pointer',...Helpers.rowCross}} onClick={()=>{
                    setDeleteAllMessages(true)
                    setShowSettings(false)
                    }}>
                    <Icon color={Colors.lightGrey} svg={deleteIcon} size="s20" />
                    <Text style={{marginLeft:Spacing.sm}}as="large" color="darkGrey">Delete All</Text>
                </View>
                <View style={{cursor:'pointer',...Helpers.rowCross}} onClick={()=>{
                    setMarkAllRead(true)
                    setShowSettings(false)
                    }}>
                    <Icon color={Colors.lightGrey} svg={checkIcon} size="s20" />
                    <Text style={{marginLeft:Spacing.sm}}as="large" color="darkGrey">Mark All Read</Text>
                </View>
                </Space>
            </View>
        </Modal>
      <Alert 
        visible={deleteMessages} 
        setVisible={setDeleteMessages} 
        title={selectedCount>1?"Delete Messages":"Delete Message"} 
        text={selectedCount>1?"Are you sure you want to delete these messages?":"Are you sure you want to delete this message?"} 
        loading = {deleteLoading}
        onPress={async ()=>{
          setDeleteLoading(true)
        }}
      />
      <Alert 
        visible={deleteAllMessages} 
        setVisible={setDeleteAllMessages} 
        title={"Delete All Messages"} 
        text={"Are you sure you want to delete all messages?"}
        loading = {deleteAllLoading}
        onPress={async ()=>{
          setDeleteAllLoading(true)
        }}
      />
      <Alert 
        visible={markAllRead} 
        setVisible={setMarkAllRead} 
        title={"Mark All Messages Read"} 
        text={"Are you sure you want to mark all messages as read?"}
        loading = {markAllReadLoading}
        onPress={async ()=>{
          setMarkAllReadLoading(true)
        }}
      />
      <Modal title='Filter' bodyStyle={{overflowY: 'auto',height:height}} open={showFilters} footer={null} onCancel={()=>setShowFilters(false)} onOk={()=>setShowFilters(false)}>
      <Row.Section title="Message Category"/>
        <Row.Checkbox
            title = "All"
            icon = {pending}
            value = {allTypes}
            onValueChange = {(newValue) => setAllTypes(newValue.target.checked)}
            />
        <Row.Checkbox
            title = "Alerts"
            icon = {pending}
            value = {alert}
            onValueChange = {(newValue) => setAlert(newValue.target.checked)}
            />
        <Row.Checkbox
            title = "Tool Related"
            icon = {pending}
            value = {tool}
            onValueChange = {(newValue) => setTool(newValue.target.checked)}
            />
        <Row.Checkbox
            title = "Team Related"
            icon = {pending}
            value = {team}
            onValueChange = {(newValue) => setTeam(newValue.target.checked)}
            />
        <Row.Checkbox
            title = "Promotions"
            icon = {pending}
            value = {promo}
            onValueChange = {(newValue) => setPromo(newValue.target.checked)}
            />

        <Row.Section title="Tool"/>
        <Row.Checkbox
            title = "All"
            icon = {pending}
            value = {allTools}
            onValueChange = {(newValue) => setAllTools(newValue.target.checked)}
            />
        {toolMacs.map((mac,index) => (
            <Row.Checkbox
                title = {allSites[mac].settings.toolName}
                icon =  {   
                            allSites[mac].toolType == ToolTypes.THP || allSites[mac].toolType == ToolTypes.SDP?thpIcon:
                            allSites[mac].toolType == ToolTypes.ANALOG_4_CH?analogIcon:
                            allSites[mac].toolType == ToolTypes.THERMO_4_CH?therm4Icon:
                            allSites[mac].toolType == ToolTypes.SWIM?swimIcon:
                            allSites[mac].toolType == ToolTypes.CHEM?chemIcon:toolIcon
                        }
                value = {_.get(toolFilters,allSites[mac].mac?allSites[mac].mac:allSites[mac].share_id)}
                onValueChange = {(newValue) => setToolFilters({[allSites[mac].mac?allSites[mac].mac:allSites[mac].share_id]:newValue.target.checked})}
            />
        ))}
      </Modal>
            </View>
            </div>
        </View>
        </View>
    )
}

export default Settings;